<script>
import DesktopInflectionScheme from "./pronouns/DesktopInflectionScheme.vue";
import MobileInflectionScheme from "./pronouns/MobileInflectionScheme.vue";
import PersonalInflectionScheme from "./pronouns/PersonalInflectionScheme.vue";

export default {
  name: "PronounInflectionSchemeModal",
  components: {
    DesktopInflectionScheme,
    MobileInflectionScheme,
    PersonalInflectionScheme
  },
  props: {
    inflectionScheme: {
      type: Object,
      required: true
    },
    lemma: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      genders: ["masculine", "feminine", "neutral"]
    };
  },
  computed: {
    isPersonalPronoun() {
      let personalKey = Object.keys(this.inflectionScheme.nominative)[0];

      // The scheme data may be nested within a gender, if so, we go one step deeper
      if (this.genders.includes(personalKey)) {
        personalKey = Object.keys(this.inflectionScheme.nominative[personalKey])[0];
      }

      return [
        "first_person_singular",
        "first_person_plural",
        "second_person_singular",
        "second_person_plural",
        "third_person_singular",
        "third_person_plural"
      ].includes(personalKey);
    },
    personalPronounScheme() {
      const scheme = {};

      for (const [casus, casusContent] of Object.entries(this.inflectionScheme)) {
        const possibleGender = Object.keys(casusContent)[0];
        let newCasusContent = casusContent;
        if (this.genders.includes(possibleGender)) {
          newCasusContent = casusContent[possibleGender];
        }

        scheme[casus] = Object.values(newCasusContent)[0];
      }

      return scheme;
    }
  }
};
</script>

<template>
  <PersonalInflectionScheme v-if="isPersonalPronoun" :scheme="personalPronounScheme" />
  <template v-else>
    <MobileInflectionScheme :scheme="inflectionScheme" class="d-lg-none" />
    <DesktopInflectionScheme :scheme="inflectionScheme" class="d-none d-lg-table" />
  </template>
</template>
